import classNames from 'classnames';
import css from './modal.module.scss';
import { FormControlLabel, Radio } from '@mui/material';
import { QuestionType } from 'src/types/quiz';

export interface AnswerProps {
  name: string;
  label: string;
  type?: QuestionType;
  isSelected: boolean;
  correctClass: boolean;
}

function SingleAnswers({ name, label, type, isSelected, correctClass }: Readonly<AnswerProps>) {
  const styles = {
    color: '#4D4634',
    '&.Mui-checked': {
      color: '#4D4634'
    }
  };

  const modLabel = type === QuestionType.ImageSelection ? <img src={label} alt={label} /> : label;

  return (
    <FormControlLabel
      className={classNames(css.answer, { [css.selected]: isSelected, [css.correct]: correctClass })}
      name={name}
      value={name}
      control={<Radio checked={isSelected} sx={styles} />}
      label={modLabel}
    />
  );
}

export default SingleAnswers;
